// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"style_wrap_d78d5252f325a72a3db92641f56e79db","rejectButton":"style_rejectButton_474cb5e04b568d4e15666a712da50a9c"};